import axios from 'axios';
import {api} from '../utils/helper';

//****************** Insert tsp ******************//
export const insertTsp = async (a) => {
    try{
        const resrep = await axios.post(`${api}/inserttsp`,a, {
            headers: {
              authorization: sessionStorage.getItem('token'),
            },
          },);
          //console.log('insertTsp controller res: ', resrep);
          return resrep;
    }catch (error) {
        //console.log('insertTsp controller error: ', error?.response?.data);
        alert(error?.response?.data?.message);
    }
  
  }


//****************** Update tsp ******************//
export const updateTsp = async (a) => {
    try{
        const resrep = await axios.put(`${api}/updatetsp`,a, {
            headers: {
              authorization: sessionStorage.getItem('token'),
            },
          },);
          //console.log('updateTsp controller res: ', resrep);
          return resrep;
    }catch (error) {
        //console.log('updateTsp controller error: ', error?.response?.data);
        alert(error?.response?.data?.message);
    }
  
  }